import axios from 'axios';

const CategoryApi = {};

const nonce = devsAccountingApi.nonce;

CategoryApi.index = async (params = null) => {
    const url = '/wp-json/devs-accounting/v1/categories/';
    try {
        const response = await axios.get(url, { params: params });
        return response.data;
    } catch (error) {
        console.error(error);
        return [];
    }
};

CategoryApi.show = async (id, params = null) => {
    const url = '/wp-json/devs-accounting/v1/get-category/' + id;
    try {
        const response = await axios.get(url, { params: params });
        return response.data;
    } catch (error) {
        console.error(error);
        return [];
    }
};

CategoryApi.delete = async (id, params = null) => {
    const url = '/wp-json/devs-accounting/v1/delete-category/' + id;
    try {
        const response = await axios.get(url, {
            headers: {
                'X-WP-Nonce': nonce
            }
        });
        return response.data;
    } catch (error) {
        console.error(error);
        return [];
    }
};

CategoryApi.save = async (data) => {
    let url = "/wp-json/devs-accounting/v1/add-category/";
    const res = await axios.post(url, data, {
        headers: {
            'X-WP-Nonce': nonce
        }
    }).then(response => {
        return response.data;
    }).catch(error => { return error.response.data; });
    return res;
}

export default CategoryApi;


// CategoryApi.save = async (data) => {
//     let url = "/wp-json/devs-accounting/v1/add-category/";
//     const res = await axios.post(url, data, {
//         headers: {
//             'X-WP-Nonce': nonce
//         }
//     }).then(response => {
//         return response.data;
//     }).catch(error => console.log('error khaici re',error.message));
//     return res;
// }

// export default CategoryApi;